import type { Pagination } from '~/types/common';
import type {
  TrainingChapterProblemVO,
  TrainingInfoVO,
  TrainingListRequestVO,
  TrainingProblemRequestVO,
  TrainingVO,
} from '~/types/training';
import { httpService } from '../http';

export function getTrainingList(query?: TrainingListRequestVO) {
  return httpService.get<Pagination<TrainingVO>>(
    `/api/code-community/api/get-training-list`,
    { query },
  );
}

export function getTrainingDetail(query: { tid: number; gid?: number }) {
  return httpService.get<TrainingInfoVO>(
    `/api/code-community/api/get-training-detail`,
    { query },
  );
}

export function getTrainingProblemList(query: TrainingProblemRequestVO) {
  return httpService.get<Pagination<TrainingChapterProblemVO>>(
    `/api/code-community/api/get-training-problem-list`,
    { query },
  );
}

export function postRegisterTraining(data: { tid: number }) {
  return httpService.post(`/api/code-community/api/register-training`, {
    body: data,
  });
}
